'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NumericValidator = exports.NumericRule = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _validator = require('validator');

var _validator2 = _interopRequireDefault(_validator);

var _Any = require('./Any');

var _helpers = require('../helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/****************************************
  Rule Builder
*****************************************/

var NumericRule = function (_AnyRule) {
  _inherits(NumericRule, _AnyRule);

  function NumericRule(rules, message) {
    _classCallCheck(this, NumericRule);

    // If this object is being made for the first time (and not chained as `setRule` does below)
    var _this = _possibleConstructorReturn(this, (NumericRule.__proto__ || Object.getPrototypeOf(NumericRule)).call(this, rules));

    if (!_this.getRule('type')) {
      _this.rules.type = message ? { rule: 'numeric', message: message } : 'numeric';
    }
    return _this;
  }

  _createClass(NumericRule, [{
    key: 'setRule',
    value: function setRule(ruleName, rule) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (typeof ruleName !== 'string') throw new Error('`ruleName` argument should be a string');
      return new NumericRule(Object.assign({}, this.toJSON(), _defineProperty({}, ruleName, !Object.keys(options).length ? rule : Object.assign({}, options, { rule: rule }))));
    }
  }, {
    key: 'toNumber',
    value: function toNumber(n) {
      var coersedNumber = n + '';
      if (!(0, _helpers.isNumeric)(coersedNumber)) throw new Error('`toNumber()`` expects a numeric string. ' + n + ' was given.');
      if (_validator2.default.isInt(coersedNumber)) return _validator2.default.toInt(coersedNumber);
      if (_validator2.default.isFloat(coersedNumber)) return _validator2.default.toFloat(coersedNumber);
    }
  }, {
    key: 'integer',
    value: function integer(message) {
      return this.setRule('integer', true, (0, _helpers.cleanObject)({ message: message }));
    }
  }, {
    key: 'float',
    value: function float(precision, message) {
      return this.setRule('float', true, (0, _helpers.cleanObject)({ precision: precision, message: message }));
    }
  }, {
    key: 'min',
    value: function min(_min, message) {
      return this.setRule('min', this.toNumber(_min), (0, _helpers.cleanObject)({ message: message }));
    }
  }, {
    key: 'max',
    value: function max(_max, message) {
      return this.setRule('max', this.toNumber(_max), (0, _helpers.cleanObject)({ message: message }));
    }
  }, {
    key: 'positive',
    value: function positive(message) {
      return this.setRule('positive', true, (0, _helpers.cleanObject)({ message: message }));
    }
  }, {
    key: 'negative',
    value: function negative(message) {
      return this.setRule('negative', true, (0, _helpers.cleanObject)({ message: message }));
    }
  }]);

  return NumericRule;
}(_Any.AnyRule);

/****************************************
  Validator
*****************************************/

var NumericValidator = function (_AnyValidator) {
  _inherits(NumericValidator, _AnyValidator);

  function NumericValidator() {
    _classCallCheck(this, NumericValidator);

    return _possibleConstructorReturn(this, (NumericValidator.__proto__ || Object.getPrototypeOf(NumericValidator)).apply(this, arguments));
  }

  _createClass(NumericValidator, [{
    key: 'type',
    value: function type(value) {
      return (0, _helpers.isNumeric)(value + '') ? '' : 'Invalid number';
    }
  }, {
    key: 'integer',
    value: function integer(value, rule) {
      return _validator2.default.isInt(value + '') ? '' : 'Invalid integer';
    }
  }, {
    key: 'float',
    value: function float(value, rule, options) {
      if (!_validator2.default.isFloat(value + '')) return 'Invalid float';
      if (Number(value) % 1 !== 0) {
        // has decimal places
        var parts = (value + '').split('.');
        if (parseInt(parts[1].length) > parseInt(options.precision)) return 'Cannot have more than ' + options.precision + ' decimal places';
      }
      return '';
    }
  }, {
    key: 'minMaxChecker',
    value: function minMaxChecker(value, rules) {
      if (_validator2.default.isInt(value)) {
        return _validator2.default.isInt(value, rules);
      } else if (_validator2.default.isFloat(value)) {
        return _validator2.default.isFloat(value, rules);
      }
    }
  }, {
    key: 'min',
    value: function min(value, rule) {
      return this.minMaxChecker(value + '', { min: rule }) ? '' : 'The smallest value allowed is ' + rule;
    }
  }, {
    key: 'max',
    value: function max(value, rule) {
      return this.minMaxChecker(value + '', { max: rule }) ? '' : 'The largest value allowed is ' + rule;
    }
  }, {
    key: 'positive',
    value: function positive(value) {
      return Number(value) > 0 ? '' : 'Value must be positive';
    }
  }, {
    key: 'negative',
    value: function negative(value) {
      return Number(value) < 0 ? '' : 'Value must be negative';
    }
  }]);

  return NumericValidator;
}(_Any.AnyValidator);

exports.NumericRule = NumericRule;
exports.NumericValidator = NumericValidator;